import { bl_fi_pick_pack_queue_RowClass } from "../../../../dbschema/bl_fi_pick_pack_queue.model";
import { BaseContainerModel } from "../../../base-container.model";

export class FinancialPickPackQueueContainerModel extends BaseContainerModel {
  bl_fi_pick_pack_queue: bl_fi_pick_pack_queue_RowClass = new bl_fi_pick_pack_queue_RowClass();
}